import React from "react";
import { Link } from "react-router-dom";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { PATH_CARDS } from "../homeV2.constants";
import Reveal from "./Reveal";

const ChoosePath = () => {
  return (
    <section className="home-v2__section" id="choose-path">
      <div className="home-v2__container">
        <Reveal as="span" className="home-v2__label">
          Choose your path
        </Reveal>
        <Reveal as="h2" className="home-v2__h2 hv2-choose-path__title" delay={0.04}>
          Two ways to grow with
          <span className="hv2-choose-path__wordmark">
            <span className="hv2-logo-icon" aria-hidden="true">
              <PlayArrowIcon fontSize="inherit" />
            </span>
            employ<span>HER</span>
          </span>
        </Reveal>
        <div className="hv2-path-grid">
          {PATH_CARDS.map((card, index) => (
            <Reveal key={card.id} delay={0.08 + index * 0.08} className="hv2-path-card">
              <span className="hv2-path-card__tag">{card.tag}</span>
              <h3 className="home-v2__h3">{card.title}</h3>
              <p className="home-v2__body-lg hv2-path-card__desc">{card.description}</p>
              <div className="hv2-path-card__mockup">
                <img src={card.mockupImage} alt={card.mockupAlt} />
              </div>
              <Link to={card.ctaTo} className="hv2-btn-text">
                {card.ctaLabel} <span>→</span>
              </Link>
              {card.subTag && <span className="hv2-path-card__subtag">{card.subTag}</span>}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChoosePath;
